import React, { forwardRef, memo } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import cx from "classnames";
import { omit } from "../../utils/utils";

const DEFAULT_PROPS = {
  className: "ifx-number-textbox",
  size: "sm",
  autoComplete: "off",
  type: "number",
  step: 1,
  numberOnly: false,
  required: false,
  readOnly: false,
};

/**
 * @deprecated In favor of IFXNumberTextBox2
 */
export const IFXNumberTextBox = memo(forwardRef((props, ref) => {
  console.warn("IFXNumberTextBox is deprecated in favor of IFXNumberTextBox2!");
  const _props = { ...DEFAULT_PROPS, className: "", ...props };
  const { maxLength, onKeyPress, required } = _props;
  let newProps = omit(_props, ["numberOnly", "required"]);

  const handleKeyPress = e => {
    //console.log("IFXNumberTextBox", e);
    let regEx;
    if (_props.numberOnly) {
      regEx = /[0-9]$/;
    } else {
      regEx = /[0-9.]$/;
    }
    if (
      e.key !== "Enter" &&
      (!regEx.test(e.key) || e.target.value.length + 1 > maxLength)
    ) {
      e.preventDefault();
      return;
    }
    if (onKeyPress) onKeyPress(e);
  };

  return (
    <>
      <Form.Control
        {...newProps}
        className={cx(DEFAULT_PROPS.className, newProps.className, {
          "field-mandatory": required,
        })}
        onKeyPress={handleKeyPress}
        ref={ref}
      />
    </>
  );
}));

IFXNumberTextBox.propTypes = {
  maxLength: PropTypes.number,
};
